import { Component } from '@angular/core';
import { PageService } from './core/page.service';
import { MenuController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Location } from '@angular/common';
import { NavigationExtras } from '@angular/router';
import { environment } from './../environments/environment';
import { LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  user: any;
  logged: any = true;
  filesUrl = environment.filesUrl + '/';
  loading: any;
  isLoading = false;
  isLoadingProcessing = false;


  constructor(
    private location: Location,
    private pageService: PageService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menu: MenuController,
    private loadingController: LoadingController,
  ) {
    this.initializeApp();
  }

  ngOnInit() {
  }

  initializeApp() {

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();


      this.pageService.global.getLoadingAsObservable().subscribe( async (result) => {
        // this.showLoading()
        result ? await this.showLoading() : await this.hideLoading();
      });
  
    });

  }

  // (+) Loading
  async showLoading(content = 'Procesando...'){
    if (this.isLoading) return;
    this.isLoading = true;
    this.isLoadingProcessing = true;

    this.loading = await this.loadingController.create({
      message: content
    });

    await this.loading.present().then( () => {
      this.isLoadingProcessing = false;
    });
  }

  async hideLoading(){
    if (this.isLoadingProcessing) {
      setTimeout(() => {
        this.hideLoading();
      }, 100);
      return;
    }
    if (this.loading) {
      this.loading.dismiss();
    }
    this.isLoading = false;
  }
  // (-) Loading



  someAction(){}
  // initializeApp() {
  //   // (+) User
  //   this.pageService.global.getUserAsObservable().subscribe((result) => {

  //     this.user = this.pageService.global.getUser();
  //     const path = this.location.path();
  //     if (!this.user) {
  //       this.logged = false;
  //     if (path != '/register/new' && path != '/recover-password') {
  //         this.pageService.navigateRoute('home');
  //       }
  //     } else {
  //       this.logged = true;
  //       if ( path == '/login' || path == '' ) {
  //         this.pageService.navigateRoute('/home');
  //       }
  //       else this.pageService.navigateRoute(path);
  //     }

  //   });
  //   this.pageService.global.checkUser();
  //   // (-) User

  //   this.platform.ready().then(() => {
  //     //this.statusBar.styleDefault();
  //     this.splashScreen.hide();
  //   });
  // }
  
}
